<!-- ══════════════════════════ VARIANTE 'animated' ══════════════════════════ -->
<section class="hero" *ngIf="variant === 'animated'">
  <!-- Fondo del panel activo, "barrido" en 4 columnas de izquierda a derecha (como la
       referencia — no es un flip/rotate, es un wipe con delay creciente por columna). Una
       capa entera por panel, cada una partida en 4 franjas que muestran distintos recortes
       de la misma imagen (ver .hero-bg-col en el scss). El wrapper .hero-bg fija su propio
       z-index para que el z-index dinámico de cada capa (ver layerZIndex) compita solo entre
       sí y nunca tape a .hero-overlay/.hero-grid. -->
  <div class="hero-bg" aria-hidden="true">
    <div class="hero-bg-layer"
         *ngFor="let panel of panels; let i = index"
         [style.z-index]="layerZIndex[i]">
      <div class="hero-bg-col"
           *ngFor="let colPos of bgCols; let c = index"
           [class.revealed]="layerRevealed[i]"
           [style.background-image]="panel.backgroundImage"
           [style.background-position-x.%]="colPos"
           [style.transition-delay.ms]="c * 90">
      </div>
    </div>
  </div>

  <div class="hero-overlay"></div>

  <!-- 6 líneas = 5 secciones (justify-content:space-between), para que coincidan con las
       5 franjas de .hero-bg-col de arriba. -->
  <div class="hero-grid" aria-hidden="true">
    <span class="hero-col"></span>
    <span class="hero-col"></span>
    <span class="hero-col"></span>
    <span class="hero-col"></span>
    <span class="hero-col"></span>
    <span class="hero-col"></span>
  </div>

  <div class="hero-header">
    <img class="logo-header" src="{{ logoPathTwo }}" alt="">

    <div class="container-contact-phone">
      <a href="https://wa.me/{{wspNumber}}"
         class="link-contact-phone"
         target="_blank"
         rel="noopener noreferrer"
      >
        <i class="bi bi-whatsapp text-white"></i>
        &nbsp;{{ wspNumber }}
      </a>
      <a href="#"
         class="link-contact-phone">
        <i class="bi bi-telephone text-white"></i>
        &nbsp;{{ phoneNumber }}
      </a>
    </div>
  </div>

  <!-- El `color` que trae cada card en section_about_us está pensado para las cards viejas
       (fondos claros/variados); acá el fondo es siempre oscuro, así que el texto va fijo en
       blanco por legibilidad — el color dinámico del cliente queda solo para los acentos
       (número grande, tab activo). -->
  <div class="hero-content hero-content--with-login" *ngIf="panels[activeIndex] as panel">
    <div class="hero-content-text" [@panelText]="activeIndex">
      <!-- <p class="hero-title-sub" *ngIf="panel.titleSub">{{ panel.titleSub }}</p> -->
      <h1 class="hero-title"
        [ngStyle]="{'max-width': getWidthHeroTitleAnimated(activeIndex)}"

      >{{ panel.title }}</h1>
      <h1 class="hero-title"
        [ngStyle]="{'max-width': getWidthHeroTitleAnimated(activeIndex)}"

      >{{ panel.titleSub }}</h1>
      <p class="hero-context" *ngIf="panel.context">{{ panel.context }}</p>
      <p class="hero-context_1" *ngIf="panel.context_1">{{ panel.context_1 }}</p>
    </div>

    <!-- El login vive dentro del hero y se mantiene visible siempre, sin importar qué panel
         esté activo (ver referencia: el form no desaparece al cambiar de pestaña). -->
    <div class="hero-login">
      <h2 class="hero-login-title">acceso a {{ clientSystemName }}</h2>

      <login
             [clientSetting]="clientSetting"
             [variant]="variant"
             (loginShowModal)="showModal = $event"
             (userDisabledEmitter)="userDisabled = $event"
      >
      </login>
    </div>
  </div>

  <!-- Template del componente -->
  <div class="modal" [ngClass]="{ show: showModal }">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Encabezado del modal -->
        <div class="modal-header">
          <h5 class="hero-login-title mt-2">Advertencia</h5>
          <!-- <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <!-- Cuerpo del modal -->
        <div class="modal-body">
          <p *ngIf="userDisabled" class="mb-1 hero-login-text-user-error">Usuario no encontrado</p>
          <p *ngIf="!userDisabled" class="mb-1 hero-login-text-user-error">Usuario o contraseña incorrecto</p>
        </div>
        <!-- Pie del modal -->
        <div class="d-flex mb-4">
          <button
                type="submit"
                class="btn-login-animated"
                  (click)="confirmAction()"
          >
            <p>
              ACEPTAR
            </p>
            <i class="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="hero-number">{{ pad(activeIndex + 1) }}</div>

  <div class="hero-nav">
    <ng-container  *ngFor="let panel of panels; let i = index">
    <button
      type="button"

      class="hero-nav-item"
      [class.active]="i === activeIndex"

      (click)="setActive(i)"
    >
      {{ pad(i + 1) }}
    </button>
     <div
           class="hero-line-nav-item"
           [class.active]="i === activeIndex"
      ></div>
      </ng-container>
  </div>

  <!-- <div class="hero-scroll-hint">SCROLL</div> -->
</section>

<!-- ══════════════════════════ VARIANTE 'classic' ══════════════════════════ -->
<!-- Las 3 cards planas originales, sin tocar — mismo markup/bindings que tenía home.component.html
     antes de meter la variante 'animated'. -->

    <div class="hero-login" *ngIf="activeIndex === 0 && variant === 'classic'">
      <h2 class="hero-login-title">Sitio exclusivo para operadores mayoristas</h2>

      <login
             [clientSetting]="clientSetting"
             [variant]="variant"
      >
      </login>
    </div>

<div class="row-seccion" *ngIf="variant === 'classic' && sectionAboutUs">
  <div class="section-about-us">
    <div class="row justify-content-center mt-3 mt-md-5" id="adjust-section-about-us">
      <div class=" mx-1" id="card-section-about-us">
        <div class="lc-block py-4 mb-4 mb-xl-0 lc-block card card-cover h-100 overflow-hidden text-white" style="background-position-y: 40px;" id="card-section-about-us"
        lc-helper="background"
        [ngStyle]="sectionAboutUs?.about?.background_image ? {'background-image': 'url(&quot;' + routeUploadFile + sectionAboutUs.about.background_image + '&quot;)'} : {'background-color': sectionAboutUs?.about?.background_color_1}">
          <div class="lc-block mb-1">
            <div editable="rich">
              <h4 class="tittle-card"
                  [ngStyle]="{'color': sectionAboutUs?.about?.color}"
              >
                {{sectionAboutUs?.about?.title}}
              </h4>
              <p class="tittle-card-sub mt-5 ml-2"
                 [ngStyle]="{'color': sectionAboutUs?.about?.color}"
              >
                {{sectionAboutUs?.about?.title_sub}}
              </p>
            </div>
          </div>
          <div class="lc-block mb-lg-5 mb-2 px-3">
            <div editable="rich">
              <p class="card-context"
                 style="margin-left: 8px;"
                 [ngStyle]="{'color': sectionAboutUs?.about?.color}"
              >
                {{sectionAboutUs?.about?.context}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class=" mx-1">
        <div class="lc-block card card-cover h-100 overflow-hidden text-white card-register" id="card-section-about-us"
              lc-helper="background"
              data-toggle="modal"
              data-target="#modalJoinus"
              (click)="openRegisterModal.emit()"
              style="background:url('{{routeUploadFile+sectionAboutUs?.tecnology?.background_image}}')  center / cover no-repeat; background-position: 65% 25%; cursor: pointer"
        >
          <div id="text-card-context">
            <div editable="rich mb-1">
              <h4 class="px-4 title-card-middle"
                  [ngStyle]="{'color': sectionAboutUs?.tecnology?.color}"
              >
                {{sectionAboutUs?.tecnology?.title}}</h4>
            </div>
            <div editable="rich">
              <p class="px-4 text-card-middle"
              style="line-height: 23px;"
              [ngStyle]="{'color': sectionAboutUs?.tecnology.color}"
            >
              {{sectionAboutUs?.tecnology?.context}}
             </p>
            </div>
          </div>
        </div>
      </div>
      <div class=" mx-1" id="card-section-about-us"
        [ngStyle]="{'background-color': sectionAboutUs?.fairs?.background_color_1}">
        <div class="lc-block py-4" *ngIf="sectionAboutUs?.fairs?.context_1">
          <div class="lc-block mb-1">
            <div editable="rich">
              <h4 class="tittle-card"
                  [ngStyle]="{'color': sectionAboutUs?.about?.color}"
              >
                {{sectionAboutUs?.fairs?.title}}
              </h4>
              <p class="tittle-card-sub mt-5 ml-2"
                 [ngStyle]="{'color': sectionAboutUs?.about?.color}"
              >
                {{sectionAboutUs?.fairs?.title_sub}}
              </p>
            </div>
          </div>
          <div class="lc-block mb-lg-5 mb-2 px-3" *ngIf="sectionAboutUs?.fairs?.context_1">
            <div editable="rich">
              <p class="card-context"
                 style="margin-left: 8px;"
                 [ngStyle]="{'color': sectionAboutUs?.about?.color}"
              >
                {{sectionAboutUs?.fairs?.context_1}}</p>
            </div>
          </div>
          <div class="lc-block mb-4" *ngIf="!sectionAboutUs?.fairs?.context_1">
            <div editable="rich">
              <h4 class="tittle-card"
                  style="margin-top: -1.4em"
                  [ngStyle]="{'color': sectionAboutUs?.fairs?.color}"
              >
                {{sectionAboutUs.fairs?.title}}
              </h4>
              <p class="tittle-card-sub mt-5 ml-2"
                 style="margin-right: 70px"
                 [ngStyle]="{'color': sectionAboutUs?.fairs?.color}"
              >
                {{sectionAboutUs.fairs?.title_sub}}
              </p>
            </div>
          </div>
          <div class="container" *ngIf="!sectionAboutUs.fairs?.context_1">
            <ng-container *ngIf="imagesAboutUs.length > 0">
              <div class="d-flex justify-content-around pb-5">
                <div class="d-flex flex-column ">
                  <img loading="lazy" class="img-responsive pb-5" src="{{images}}" alt="" width="60px" *ngFor="let images of imagesAboutUs">
                </div>
                <div class="d-flex flex-column" style="width:120px;">
                  <div *ngFor="let title of titleContext">
                    <p [ngStyle]="{'color': sectionAboutUs.fairs.color}" class="mb-0">
                      <span style="font-weight: 600;">{{title}}</span>
                    </p>
                    <p style="font-size: 13px; font-weight: 400;" [ngStyle]="{'color': sectionAboutUs.fairs.color}">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
